import { gql } from '@apollo/client';

export const SHINY_URL = gql`
  query shinyUrl($page: String!, $iso: String, $assetName: String) {
    shinyUrl(page: $page, iso: $iso, assetName: $assetName) {
      url
    }
  }
`;
